import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'thumb-up-down-feedback',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (feedback()) {
      {{ 'tlc.hr_assistant.thanks_for_feedback' | translate }}
    } @else {
      @if (showLabel()) {
        <span text-color>
          {{ 'tlc.hr_assistant.like_it' | translate }}
        </span>
      }
      <rt-icon-button
        size="small"
        iconName="rating-thumb-up"
        variant="plain"
        [class.reversed]="reverseThumbsUp()"
        (click)="feedback.set('up')"
      />
      <rt-icon-button
        size="small"
        iconName="rating-thumb-down"
        variant="plain"
        (click)="feedback.set('down')"
      />
    }
  `,
  imports: [IconButtonComponent, TranslatePipe],
  styleUrl: './thumb-up-down-feedback.component.less',
})
export class ThumbUpDownFeedbackComponent {
  public feedback = model<'up' | 'down' | null>(null);
  public showLabel = input<boolean>(true);
  public reverseThumbsUp = input<boolean>(false);
}
